import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  Row,
  Table,
} from "reactstrap";
import {
  deleteContactsData,
  getContactsDataAddress,
  postContactsDataCreate,
} from "../../../../helpers/backend";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import { useSelector } from "react-redux";
import { capitalizeFirstLetter } from "../../../../utils/capitalizeFirstLetter";
import CountryStateCitySelect from "../../../../components/CountryStateCitySelect";

const AddressList = () => {
  const contactoId = useParams().id;
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);

  const optionGroupLabel = [
    {
      options: [
        { label: "Principal", value: "Principal" },
        { label: "Trabajo ", value: "Trabajo" },
        { label: "Casa ", value: "Casa" },
        { label: "Otro ", value: "Otro" },
      ],
    },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [tipoContacto, setTipoContacto] = useState(null);
  const [dataText, setDataText] = useState(null);
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [zipCode, setZipCode] = useState(null);
  const [datoId, setDatoId] = useState(null);

  const [addressData, setAddressData] = useState({});
  const getAddressData = async () => {
    const response = await getContactsDataAddress(contactoId);
    const data = response.data;
    setAddressData(data);
  };
  const HandleDelete = async () => {
    await deleteContactsData(datoId);
    setConfirm(false);
    getAddressData();
  };
  useEffect(() => {
    getAddressData();
    // eslint-disable-next-line
  }, []);

  const handleLocationChange = (location) => {
    console.log('Location selected:', location);
    setCountry(location.country);
    setState(location.state); 
    setCity(location.city);
  };

  const onSubmit = async () => {
    await postContactsDataCreate({
      contact: contactoId,
      label: tipoContacto,
      tipo: "Direccion",
      value_1: dataText,
      country: country,
      state: state,
      city: city,
      zip_code: zipCode,
    });
    setIsOpen(false);
    getAddressData();
  };

  const theme = useSelector((state) => state.theme.theme) || "light";

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} centered={true} toggle={() => setIsOpen(false)}>
        <div
          className="modal-header"
          style={{ backgroundColor: theme === "dark" && "#242424" }}
        >
          <h4 className="modal-title mt-1">Nueva Dirección</h4>
        </div>

        <Row className="d-flex justify-content-center mb-2 mt-2">
          <Col style={{ maxWidth: "325px" }}>
            <CountryStateCitySelect onLocationChange={handleLocationChange} />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mb-2">
          <Col style={{ maxWidth: "325px" }}>
            <Input
              type="text"
              placeholder="Código postal"
              value={zipCode}
              onChange={(item) => setZipCode(item.target.value)}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center mb-2">
          <Col style={{ maxWidth: "325px" }}>
            <Select
              id="tipo_Contacto"
              name="tipo_Conatcto"
              options={optionGroupLabel}
              placeholder="Seleccione un tipo de dirección"
              onChange={(e) => setTipoContacto(e.value)}
              autoFocus
              required
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: theme === "dark" ? "#2c2c2c" : "#fff",
                  color: theme === "dark" ? "#c3cbe4" : "#000",
                  borderColor: theme === "dark" ? "#3b3b3b" : "#e9ebec",
                  cursor: "pointer",
                  fontSize: "0.9rem",
                }),
                menu: (base) => ({
                  ...base,
                  backgroundColor: theme === "dark" ? "#242424" : "#fff",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                }),
                option: (base, { isFocused, isSelected }) => ({
                  ...base,
                  backgroundColor: isSelected
                    ? theme === "dark"
                      ? "#242424"
                      : "#ccc"
                    : isFocused
                    ? theme === "dark"
                      ? "#121212"
                      : "#ddd"
                    : "transparent",
                  color: theme === "dark" ? "#c3cbe4" : "#000",
                  padding: "10px",
                  fontSize: "0.9rem",
                  cursor: "pointer",
                }),
                singleValue: (base) => ({
                  ...base,
                  color: theme === "dark" ? "#c3cbe4" : "#000",
                }),
              }}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col style={{ maxWidth: "325px" }}>
            <Input
              type="textarea"
              placeholder="Escriba una dirección"
              value={dataText}
              onChange={(item) => setDataText(item.target.value)}
            />
          </Col>
        </Row>

        <Row className="mt-3 p-3">
          <Col className="d-flex justify-content-center gap-2">
            <button
              className="button_cancel"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              Cancelar
            </button>
            <button
              className="button_create"
              onClick={() => {
                onSubmit();
              }}
            >
              Guardar
            </button>
          </Col>
        </Row>
      </Modal>
      {confirm ? (
        <SweetAlert
          title="¿Estás seguro de que quieres eliminar este dato de contacto ?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={HandleDelete}
          onCancel={() => setConfirm(false)}
        ></SweetAlert>
      ) : null}
      {groups.includes("SuperAdmin") ||
      groups.includes("Administrador") ||
      groups.includes("Supervisor") ||
      groups.includes("Agente") ? (
        <Button
          className="btn btn-primary waves-effect waves-light btn-sm mb-1"
          color="success"
          onClick={() => setIsOpen(true)}
        >
          Agregar Nueva Dirección
        </Button>
      ) : null}
      <Card>
        <CardBody className="pb-0">
          <h4 className="card-title">Direcciones</h4>

          {addressData.count !== 0 ? (
            <div>
              <Table className="table text-center " hover responsive>
                <thead 
                style={{backgroundColor: "#C8E6C9" }}>
                  <tr>
                    <th>#</th>
                    <th>Tipo</th>
                    <th>País</th>
                    <th>Estado</th>
                    <th>Ciudad</th>
                    <th>Dirección</th>
                    <th>Código postal</th>
                    {groups.includes("SuperAdmin") ||
                    groups.includes("Administrador") ||
                    groups.includes("Supervisor") ? (
                      <th>Acción</th>
                    ) : null}
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(addressData.results)
                    ? addressData.results.map((dato, idx) => (
                        <tr key={idx}>
                          <th scope="row">{idx + 1}</th>
                          <td>{dato.label}</td>
                          <td>{capitalizeFirstLetter(dato.country)}</td>
                          <td>{capitalizeFirstLetter(dato.state)}</td>
                          <td>{capitalizeFirstLetter(dato.city)}</td>
                          <td>{capitalizeFirstLetter(dato.value_1)}</td>
                          <td>{dato.zip_code || "-"}</td>
                          <td>
                            {groups.includes("SuperAdmin") ||
                            groups.includes("Administrador") ||
                            groups.includes("Supervisor") ? (
                              <Link to="#">
                                <span
                                  className="bx bx-trash bx-sm align-middle"
                                  onClick={() => {
                                    setConfirm(true);
                                    setDatoId(dato.id);
                                  }}
                                ></span>
                              </Link>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    : []}
                </tbody>
              </Table>
            </div>
          ) : (
            <CardBody>
              <h4 className="card-title">No se encontraron resultados</h4>
            </CardBody>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};
export default AddressList;
